Vue.component('promote-reputation', {
    data: function() {
        return {
            theme: 'light',
            active: false
        }
    },
    computed: {
        teamId () {
            return Spark.state.currentTeam.id;
        }
    },
    mounted() {
        const that = this;
        this.$eventHub.$on('activateTab', (id) => {
            if (id == 'promote-reputation') {
                that.active = true;
                that.loadWidgetScript();
            }
        });
    },
    methods: {
        loadWidgetScript() {
            if (!document.querySelector('script[src="' + process.env.MIX_WIDGETS_LOADER_URL + '"]')) {
                let widgetLoader = document.createElement('script');
                widgetLoader.setAttribute('src', process.env.MIX_WIDGETS_LOADER_URL);
                document.body.appendChild(widgetLoader);
            }
        },
        getEmbedInstructions(theme) {
            this.theme = theme;
            $(this.$refs.embed_instructions_modal).modal('toggle');
        },
        getPreviewUrl() {
            return process.env.MIX_PAGES_URL + '/widget/' + 0 + '?teamId=' + Spark.state.currentTeam.id + '#next';
        }
    }
});
